'use client';

import { Suspense } from 'react';
import Providers from './Providers';
import PersistentHeader from '@/components/layout/PersistentHeader';

export default function ProvidersWrapper({ children }: { children: React.ReactNode }) {
  const base = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:4000';

  return (
    <Providers>
      <Suspense fallback={null}>
        <PersistentHeader base={base}>
          {children}
        </PersistentHeader>
      </Suspense>
    </Providers>
  );
}

